import React, {useEffect, useRef, useContext} from "react"
import Flicking from "@egjs/react-flicking"
import { FlickingError, ERROR_CODE } from "@egjs/react-flicking";

import elementInside from "../../experience/dataExperience";
import Context from "../../store/context";

const PhotoSlider = props => {
    
    const lang = document.documentElement.lang === "it"


    const colorCtx = useContext(Context)
    const flickRef2 = useRef()

    const cursorEnter = (el) => {
        console.log("e" + el);
        document.getElementById("cursorID").classList.add(el);
    }
    const cursorLeave = (el) => {
        console.log("e" + el);
        document.getElementById("cursorID").classList.remove(el);
    }
    
    useEffect(() => {
      document.getElementById(props.cN).addEventListener('mouseenter', () => {
          document.getElementById("cursorID").classList.add("view");
      });
      document.getElementById(props.cN).addEventListener('mouseleave', () => {
          document.getElementById("cursorID").classList.remove("view");
      });
        async function sync(){
            try {
                  await flickRef2.current.moveTo(colorCtx.color);
            }
            catch (err) {
              if (err instanceof FlickingError) {
                if (err.code === ERROR_CODE.ANIMATION_ALREADY_PLAYING) {
                } else if (err.code === ERROR_CODE.ANIMATION_INTERRUPTED) {
                }
              }
            }
          }
          sync()  
    },[colorCtx.color])

    
    // <img alt="" src={element.photo} style={{backgrounColor: "red", width: "20%", height: "auto",margin: "12px 1%", boxShadow: id === colorCtx.color && "0px 12px " + element.color, pointerEvents: "auto", cursor: "pointer" }} key={id}></img>
    return(
        <div className={props.cN} id={props.cN}>
            <Flicking
                ref={flickRef2}
                align = '{camera: "50%"}'
                horizontal = {true}
                circular = {true}
                defaultIndex = {colorCtx.color}
                onSelect={(e) => {document.location.href = `${lang ? elementInside[e.index].name.it : elementInside[e.index].name.en}.html`}}
                onWillChange={(e) => colorCtx.setColor(e.index)}
            >   
              {elementInside.map((element, id) => <img key={id} alt="" src={element.photo} onMouseEnter={() => cursorEnter("view")} onMouseLeave={() => cursorLeave("view")} className={"flicking-camera-img"} style={{backgrounColor: "red",width: "15%", height: "auto",margin: "12px 1%", boxShadow: id === colorCtx.color && "0px 12px " + element.color, pointerEvents: "auto", cursor: "pointer" }} /> )}
            </Flicking>
        </div>
    )
}

export default PhotoSlider